query eventMappingDetailsExt($id: String, $feed: String) {
  allEventMappings(
    filter: { extId: { equalTo: $id }, feed: { equalTo: $feed } }
  ) {
    nodes {
      competitorExtIds
      sportsLabel
      intId
      extRef
      extId
      feed
      createdAt
      updatedAt
      updatedBy
      startsAtUtc
      mappingId
      mappingType
      competitorsFlipped
      eventCompetitorMappingsByEventMappingIdAndFeed {
        nodes {
          competitorMapping {
            extId
            extRef
            feed
            intId
            mappingId
            mappingType
          }
        }
      }
      playerTeamEventMappingsByFeedAndEventExtId {
        nodes {
          teamExtId
          playerExtId
          feed
          discriminator
          baseballPlayerMapping {
            extRef
            extId
            feed
            intId
            mappingType
            mappingId
          }
          footballPlayerMapping {
            extId
            extRef
            feed
            intId
            mappingId
            mappingType
          }
          basketballPlayerMapping {
            extId
            extRef
            feed
            intId
            mappingId
            mappingType
          }
          hockeyPlayerMapping {
            extId
            extRef
            feed
            intId
            mappingType
            mappingId
          }
          soccerPlayerMapping {
            extId
            extRef
            feed
            intId
            mappingId
            mappingType
          }
          ultimatePlayerMapping {
            extId
            extRef
            feed
            intId
            mappingId
            mappingType
          }
          tennisPlayerMapping {
            extId
            extRef
            feed
            intId
            mappingId
            mappingType
          }
        }
      }
      competitionMapping {
        extId
        extRef
        feed
        intId
        mappingId
        mappingType
        regionMapping {
          extId
          extRef
          intId
          feed
          mappingType
          mappingId
        }
        mappedEntity {
          competitionName
          limbo
          regionId
          sportId
          ageCategory
          gender
          source
        }
      }
      createdBy
    }
  }
}
